export const dateFormater = (timestamp) => {
  const formatDate = new Date(timestamp);
  const dateFormated = formatDate.getDate() + '/' + (formatDate.getMonth() + 1) + '/' + formatDate.getFullYear();
  return dateFormated;
};
